'use client';
var IDENT = "Group";
var defaultProps = {
    position: "left",
    align: "center",
    spacing: "4s"
};

export { IDENT, defaultProps };
